import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledTrustPilotBannerVariant1 = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: 8px;
    background-color: ${Color.SKY_LIGHTER};

    padding: 4px 8px;
    margin-bottom: 16px;
  `,
  Separator: styled.div`
    width: 1px;
    height: 80%;
    background: ${Color.SKY_DARK};
  `,
  Text: styled.span<{ $nowrap?: boolean }>`
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: ${Color.INK_BASE};
    white-space: ${({ $nowrap }) => ($nowrap ? 'nowrap' : 'normal')};

    & strong {
      font-weight: 700;
      color: ${Color.INK_DARKER};
    }
  `,
  Block: styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
}
